<div class="position-relative" [class.has-selection]="hasSelection">
  <!-- Search Input -->
  <div class="input-group">
    <span class="input-group-text">
      <i class="bi" [ngClass]="isLoading ? 'bi-arrow-repeat spin' : 'bi-search'"></i>
    </span>
    <input
      #searchInput
      type="text"
      class="form-control"
      [placeholder]="placeholder"
      [value]="searchQuery"
      (input)="onSearchInput($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      [disabled]="disabled"
      autocomplete="off"
      role="combobox"
      aria-haspopup="listbox"
      [attr.aria-expanded]="isOpen"
    >
    <button
      *ngIf="hasSelection"
      type="button"
      class="btn btn-outline-secondary"
      (click)="clearSelection()"
      title="Clear selection"
    >
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <!-- Selected Chemical Details -->
  <div *ngIf="hasSelection && selectedChemical" class="py-1 mt-2">
    <div class="d-flex align-items-center gap-2 flex-wrap">
      <span class="badge" [ngClass]="getSourceBadgeClass(selectedChemical.source)">
        {{ getSourceLabel(selectedChemical.source) }}
      </span>
      <span *ngIf="showCategory" class="badge" [ngClass]="getCategoryBadgeClass(selectedChemical.category)">
        {{ selectedChemical.category | titlecase }}
      </span>
      <span *ngIf="showEpaNumber" class="text-muted small">
        EPA #{{ selectedChemical.epaNumber }}
      </span>
    </div>
  </div>

  <!-- Dropdown Results -->
  <div
    #dropdown
    class="dropdown-menu typeahead-dropdown"
    [class.show]="isOpen && results.length > 0"
    role="listbox"
  >
    <div class="dropdown-scroll">
      <button
        *ngFor="let chemical of results; let i = index"
        type="button"
        class="dropdown-item"
        [class.active]="i === highlightedIndex"
        (click)="selectChemical(chemical)"
        (mouseenter)="highlightedIndex = i"
        role="option"
        [attr.aria-selected]="i === highlightedIndex"
      >
        <div class="chemical-result">
          <div class="d-flex justify-content-between align-items-start gap-2">
            <div class="chemical-info flex-grow-1">
              <div class="chemical-name fw-medium">{{ chemical.displayName || chemical.name }}</div>
              <!-- Show EPA name if displayName differs -->
              <div *ngIf="chemical.displayName && chemical.displayName !== chemical.name" class="chemical-alt-name text-muted small">
                EPA Name: {{ chemical.name }}
              </div>
              <!-- Show matching alternate name if search matched there -->
              <div *ngIf="hasAltNameMatch(chemical)" class="chemical-match-info small">
                <i class="bi bi-arrow-return-right me-1"></i>
                <span class="text-primary">Matches: {{ getMatchingAltName(chemical) }}</span>
              </div>
            </div>
            <div class="d-flex gap-1 flex-shrink-0">
              <span class="badge badge-sm" [ngClass]="getSourceBadgeClass(chemical.source)">
                {{ getSourceLabel(chemical.source) }}
              </span>
            </div>
          </div>
          <div class="chemical-details text-muted small mt-1">
            <span *ngIf="showEpaNumber" class="epa-number-inline">EPA #{{ chemical.epaNumber }}</span>
            <span *ngIf="chemical.activeIngredient">
              <span class="mx-1">&bull;</span>
              {{ chemical.activeIngredient }}
            </span>
          </div>
        </div>
      </button>
    </div>

    <!-- Browse All Link -->
    <div class="dropdown-divider"></div>
    <a routerLink="/logbook/chemicals/book" class="dropdown-item text-primary browse-all">
      <i class="bi bi-book me-2"></i>Browse Full Chemical Book
    </a>
  </div>

  <!-- No Results -->
  <div
    class="dropdown-menu typeahead-dropdown"
    [class.show]="isOpen && results.length === 0 && searchQuery.length >= 2 && !isLoading"
  >
    <div class="dropdown-item text-muted no-results">
      <i class="bi bi-search me-2"></i>
      No chemicals found matching "{{ searchQuery }}"
    </div>
    <div class="dropdown-divider"></div>
    <a routerLink="/logbook/chemicals/book" class="dropdown-item text-primary browse-all">
      <i class="bi bi-book me-2"></i>Browse Full Chemical Book
    </a>
  </div>

  <!-- Minimum Characters Hint -->
  <div class="form-text" *ngIf="!hasSelection && searchQuery.length > 0 && searchQuery.length < 2">
    Type at least 2 characters to search
  </div>
</div>
